const tabsUser = {
  active: 'ACTIVE',
  invite: 'INVITATIONS',
  Typography: 'No results found'
};

export default tabsUser;
